import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (
                (AuthService.getActiveMember() && AuthService.getActiveMember().isSignupFinished) ||
                AuthService.isUserPracticeOther()
            ) {
                return next()
            }

            next({ name: 'auth.signup' })
        })
    },
}
